import { Component, ElementRef, HostBinding, Inject, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { FuseConfigService } from '../core/services/config.service';
import { Platform } from '@angular/cdk/platform';
import { Router} from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ServiciosGenerales } from '../main/content/Servicios/ServiciosGenerales.service';
import { AuthService } from '../main/content/Seguridad/auth.service';




@Component({
    selector     : 'fuse-main',
    templateUrl  : './main.component.html',
    styleUrls    : ['./main.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FuseMainComponent implements OnInit, OnDestroy
{
    onSettingsChanged: Subscription;
    fuseSettings: any;
    @HostBinding('class.boxed') boxed;

    constructor(
        private _renderer: Renderer2,
        private _elementRef: ElementRef,
        private fuseConfig: FuseConfigService,
        private serviciosGenerales:ServiciosGenerales, 
        private platform: Platform,
        private auth: AuthService,
        private router: Router,
        @Inject(DOCUMENT) private document: any
    )
    {
        this.onSettingsChanged =
            this.fuseConfig.onSettingsChanged
                .subscribe(
                    (newSettings) => {
                        this.fuseSettings = newSettings;
                        this.boxed = this.fuseSettings.layout.mode === 'boxed';
                    }
                );

        if ( this.platform.ANDROID || this.platform.IOS )
        {
            this.document.body.className += ' is-mobile';
        }

        window.addEventListener('beforeunload', function (e) {
           // console.log(window.performance.getEntriesByType('navigation')[0].entryType.);
           // console.log(window.performance.navigation.TYPE_RELOAD == 0);
           //window.opener.window.location.reload (true);
           // if(performance.navigation.type == 0){
            serviciosGenerales.post('guardar/cierreSesion', {usuario : serviciosGenerales.seguridad.getInfoSesion().usuario,empresa : JSON.parse(serviciosGenerales.seguridad.getInfoToken().empresa).empresa}).subscribe(x=>{
                console.log("cerrar sesion");
            });
         //   }
            return null;
        });

        window.addEventListener('popstate', function(event) {

            if (this.document.location.pathname == "/login") {
                serviciosGenerales.post('guardar/cierreSesion', {usuario : serviciosGenerales.seguridad.getInfoSesion().usuario,empresa : JSON.parse(serviciosGenerales.seguridad.getInfoToken().empresa).empresa}).subscribe(x=>{
                    console.log("cerrar sesion");
                    router.navigate(['']);
                    auth.clearSession(serviciosGenerales);
                });
                history.back();
                history.pushState(null, null, window.location.pathname);
            }
        
        }, false);
    }

    ngOnInit()
    {
    }

    ngOnDestroy()
    {   
        this.onSettingsChanged.unsubscribe();
    }

    addClass(className: string)
    {
        this._renderer.addClass(this._elementRef.nativeElement, className);
    }

    removeClass(className: string)
    {
        this._renderer.removeClass(this._elementRef.nativeElement, className);
    }
}




// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/main.component.ts